<template>
  <div class="content-wrapper">
    <div class="content">
      <h1>Dernières questions !</h1>
      <div class="notification">
        Vous avez terminé les neuf étapes, merci beaucoup pour votre
        participation. Et vous, personnellement, qu’en pensez-vous ?
      </div>
      <div class="form-wrapper">
        <hi-form :form="form" @submit="submit">
          <div class="notification">
            <p>
              La thématique de la diversité vous préoccupe-t-elle dans le cadre
              de votre activité à l’ACV ?
            </p>
            <div class="radio-wrapper">
              <hi-radio value="Non" label="Non" name="concern"></hi-radio>
              <hi-radio
                value="Oui un peu"
                label="Oui, un peu"
                name="concern"
              ></hi-radio>
              <hi-radio
                value="Oui beaucoup"
                label="Oui, beaucoup"
                name="concern"
              ></hi-radio>
            </div>
          </div>
          <div class="notification">
            <p>
              Dans votre service, estimez-vous que le nécessaire soit fait pour
              y répondre ?
            </p>
            <div class="radio-wrapper">
              <hi-radio label="Non" name="service"></hi-radio>
              <hi-radio
                value="Oui un peu"
                label="Oui un peu, mais on pourrait faire mieux"
                name="service"
              ></hi-radio>
              <hi-radio
                value="Oui tout à fait"
                label="Oui, tout à fait"
                name="service"
              ></hi-radio>
            </div>
          </div>
          <div class="notification">
            Quel(s) thème(s) vous concerne(nt) le plus dans votre pratique
            professionnelle ?
            <div class="input-block-wrapper">
              <hi-checkbox
                label="Recourt à l’interprétariat / traduction"
                name="theme"
                value="Recourt à l’interprétariat / traduction"
                id="c1"
              ></hi-checkbox>
              <hi-checkbox
                label="Gestion de la diversité au sein de l’équipe"
                name="theme"
                value="Gestion de la diversité au sein de l’équipe"
                id="c2"
              ></hi-checkbox>
              <hi-checkbox
                label="Amélioration de l’accueil et de la communication pour les personnes migrantes"
                name="theme"
                value="Amélioration de l’accueil et de la communication pour les personnes migrantes"
                id="c3"
              ></hi-checkbox>
              <hi-checkbox
                label="Réaction à des propos et/ou des situations discriminatoires"
                name="theme"
                value="Réaction à des propos et/ou des situations discriminatoires"
                id="c4"
              ></hi-checkbox>
            </div>
            <hi-checkbox
              id="c5"
              value="autre"
              label="Autre : à spécifier"
              name="theme"
            ></hi-checkbox>
            <hi-input
              name="autre"
              type="text"
              placeholder="Autre thème qui vous concerne"
            ></hi-input>
          </div>
          <hi-textarea
            label="Souhaitez-vous nous faire part de questions, de suggestions ou d’un témoignage ? "
            name="comment"
            placeholder="Vos questions, suggestions ou témoignage ici"
            rows="8"
          >
          </hi-textarea>
          <div>
            <button class="button">Soumettre</button>
          </div>
        </hi-form>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "./../bus";
import HIForm from "./../objects/HIForm.js";
import SessionMixin from "./../mixins/SessionCookieMixin";
export default {
  mixins: [SessionMixin],

  data() {
    return {
      found: false,
      session_id: "",
      link_to: "",
      name: "",
      form: new HIForm({ theme: [] }),
    };
  },
  computed: {
    env() {
      return process.env;
    },
  },
  methods: {
    submit() {
      let vm = this;
      if (this.form.empty()) {
        return vm.$router.push({ name: "Final" });
      }
      var Airtable = require("airtable");
      var base = new Airtable({ apiKey: "keywRmwJEofgnhPXa" }).base(
        "appq0XHVNxg4y3RZF"
      );
      let quand = new Date().toISOString().substring(0, 10);
      let form = this.form;

      base("Commentaires").create(
        {
          Quand: quand,
          Préoccupation: form.concern,
          Service: form.service,
          Thème: form.theme,
          Autre: form.autre,
          Commentaire: form.comment,
        },
        function (err, record) {
          if (err) {
            console.error(err);
            return;
          }
          console.log(record.getId());
        }
      );
      vm.$router.push({ name: "Final" });
    },
  },
  mounted() {
    const session = this.$cookies.get("bci_session");
    bus.$emit("quizUpdated", 10);
  },
};
</script>
